module.exports = __webpack_public_path__ + "static/gradientThree-608fde2d00ab8c7e6900a1b0a67bc73e.png";